import { env } from "@/next.config";
import httpUtils from "@/utils/httpUtils";

export async function createCuratedShortlistPayment(data, config) {
    return httpUtils.post(`${env.API_VERSION}/curated-shortlist/create-payment`, data, config);
}

export async function getCuratedShortlistSession(sessionId, config) {
    return httpUtils.get(`${env.API_VERSION}/curated-shortlist/session/${sessionId}`, config);
}

export async function submitCuratedShortlistIntake(data, config) {
    return httpUtils.post(`${env.API_VERSION}/curated-shortlist/submit-intake`, data, {
        ...config,
        headers: { "Content-Type": "multipart/form-data", ...config?.headers },
    });
}

export async function getCuratedShortlistStatus(config) {
    return httpUtils.get(`${env.API_VERSION}/curated-shortlist/status`, config);
}
